import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import TestimonialsSection from "@/components/feature/TestimonialsSection";
import { useSiteSettings } from "@/hooks/useSiteSettings";

export default function TestimonialsPage() {
  const { site } = useSiteSettings();

  return (
    <div className="min-h-screen bg-white font-body">
      <Navbar />
      <main className="w-full bg-neutral-50">
        <section className="w-full bg-brand-dark py-12 md:py-16">
          <div className="mx-auto max-w-7xl px-4 md:px-6 text-center">
            <span className="text-xs font-medium uppercase tracking-widest text-brand-gold">
              Customer Reviews
            </span>
            <h1 className="mt-2 font-heading text-3xl md:text-4xl font-semibold uppercase text-white">
              Testimonials
            </h1>
            <p className="mx-auto mt-3 max-w-2xl text-sm text-white/60 leading-relaxed">
              Real feedback from mechanics, workshops and owners across Australia who trust{" "}
              {site.site_name} for quality used engines, transmissions and body parts.
            </p>
          </div>
        </section>

        <TestimonialsSection
          title="Trusted Australia-Wide"
          subtitle="From Darwin to Hobart and Perth to Brisbane — hear from customers who found the right part, at the right price, delivered fast."
        />
      </main>
      <Footer />
    </div>
  );
}